import React, { useContext } from 'react';
import UserContext from '@context/User/user-context';
import { Room } from '@graphql/Room/queries/get-room.graphql';
import useIsHighValueCustomer from '@hooks/User/useIsHighValueCustomer';

interface IDesignerAvail {
  soonestWeekAvailable: number;
  weekAvailableText: string;
  soonestHvcWeekAvailable: number;
  hvcWeekAvailableText: string;
}

interface IProps {
  designer: IDesignerAvail;
  room?: Room;
}

const DesignerAvailableText = ({ designer, room }: IProps) => {
  const { user } = useContext(UserContext);
  const { isHighValueCustomer } = useIsHighValueCustomer(user, room);
  const availText =
    isHighValueCustomer ? designer.hvcWeekAvailableText : designer.weekAvailableText;

  return (
    <>Available { availText }</>
  );
};

export default DesignerAvailableText;
